// @flow
import PageRematch from 'components/page/template/PageRematch';
import { postRematchForm } from 'actions/rematchFormActions';
import { connect } from 'react-redux';
import { fetchRematch } from 'actions/rematchFormActions';

import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/page/template/PageRematch';


export default connect(
  (state: StateType): StateProps => ({
    rematchVote: state.appState.rematchVote,
    datarematch: state.rematchFormState.data,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    onSubmit: (formInputs: Object) => dispatch(postRematchForm(formInputs)),
    fetchRematch: () => dispatch(fetchRematch())
  })
)(PageRematch);
